import { useTheme } from "@/hooks/theme";
import { ThemedView } from "../ThemedView";
import { useLocale } from "@/hooks/locale";

export const AlertView = (props: {
    type?: null | "success" | "primary" | "error" | "warning";
    message?: null | string;
    messages?: null | string;
    onClear?: () => void;
}) => {
    const theme = useTheme();
    const { t } = useLocale();

    if (!props.message || !props.type) {
        return <></>;
    }

    const backgroundColor: string = theme.colors[props.type] + "33";
    const textColor: string = theme.colors[props.type];

    return (
        <ThemedView
            style={{
                border: `solid 1px ${textColor}`,
                borderRadius: "12px",
                background: backgroundColor,
                padding: "16px",
                paddingTop: props.onClear ? "8px" : undefined,
                color: textColor,
                gap: "8px",
            }}
        >
            {props.onClear && (
                <>
                    <ThemedView
                        style={{
                            flexDirection: "row",
                            justifyContent: "end",
                            alignItems: "center",
                            fontSize: "24px",
                        }}
                    >
                        <ThemedView
                            onClick={() => {
                                props.onClear?.();
                            }}
                        >
                            ×
                        </ThemedView>
                    </ThemedView>
                </>
            )}
            <ThemedView>{t(props.message)}</ThemedView>
        </ThemedView>
    );
};